import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class FileStatusService {
  readonly rootUrl = AppSettings.webApiURL;
  constructor(public httpClient: HttpClient) { }

  getRole() {
    return this.httpClient.get(`${this.rootUrl}/api/FileStatusAPI/GetRole`);
  }
  getCustomerDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/FileStatusAPI/GetListCustomerDDL`);
  }
  getReport(statusId: any, customerId: any, fromDate, toDate, dateOptionSelected) {
    return this.httpClient.get(`${this.rootUrl}/api/FileStatusAPI/GetReport?statusId=${statusId}&customerId=${customerId}&from=${fromDate}&to=${toDate}&dateOption=${dateOptionSelected}`);
  }
  setStatus(fileId: number) {
    return this.httpClient.put(`${this.rootUrl}/api/FileStatusAPI/PutFile`, fileId);
  }
  getDownloadFile(fileName: string, MISPAR_ZIHUY_MAASIK: string) {
    // const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.get(`${this.rootUrl}/api/FileStatusAPI/GetDownloadFile?fileName=${fileName}&cId=${MISPAR_ZIHUY_MAASIK}`,{ responseType: 'blob' });
  }
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/file-status.service.ts